import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
//
import DidntFindWhatYouWereLookingFor from "../../../organisms/Common/DidntFindWhatYouWereLookingFor";
import SubscribeToEmailList from "../../../organisms/Common/SubscribeToEmailList";
import InnuaPartners from "../../../organisms/Common/InuuaPartners";
import Testimonials from "../../../organisms/Testimonials/TestimonialsOld";
import FilterPlans from "../../../organisms/Plans/FilterPlans";
import countPlanFeatures from "../../../../utils/plans/countPlanFeatures";
import deepCopyObject from "../../../../utils/deepCopyObject";
import filterHousePlans from "../../../../utils/plans/filterHousePlans";
import getPlanFilterFromUrl from "../../../../utils/plans/getPlanFilterFromUrl";
import defaultPlanSelection from "../../../../utils/plans/defaultPlanSelection";
import PlanCardsList from "../../../organisms/Plans/PlanCardsList";

function AllPlans(props) {
    const router = useRouter();
    const [plansFeatures, setplansFeatures] = useState({});
    const [plans, setplans] = useState(props.plans);
    const [filterOpen, setfilterOpen] = useState(false);
    const [selectedFilters, setselectedFilters] = useState(
        defaultPlanSelection
    );
    const allPlansFeatures = React.useMemo(
        () => deepCopyObject(countPlanFeatures(props.plans)),
        [props.plans]
    );

    // filter plans by selectedFilters
    // count update plan features
    useEffect(() => {
        updatePlans();
    }, [props.plans, selectedFilters]);

    // update filters from url
    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.log("router");
            console.table(router.query);
            console.log(router.query);
            console.log(router);
            console.log(router.asPath);
        }
        setselectedFilters(deepCopyObject(getPlanFilterFromUrl(router.query)));
        updatePlans();
    }, [router.query]);

    // update visible plan information on the UI
    function updatePlans() {
        const newPlans = filterHousePlans(
            props.plans,
            selectedFilters.house_type,
            selectedFilters.bedrooms,
            selectedFilters.bathrooms,
            selectedFilters.minimum_plot_size
        );
        setplans(deepCopyObject(newPlans));
        setplansFeatures(deepCopyObject(countPlanFeatures(newPlans)));
    }

    function resetFilters() {
        setselectedFilters(deepCopyObject(defaultPlanSelection));
        setfilterOpen(false);
        router.push({
            pathname: "/plans",
            shallow: true,
        });
    }

    return (
        <>
            <main>
                {/* <--------------------------------------------- Introduction ------------------------------------> */}
                <AllPlansIntros setfilterOpen={setfilterOpen} />
                {/* <------------------------------------------------------- Filter Plans ------------------------------------> */}
                {Object.keys(plansFeatures).length > 0 && (
                    <FilterPlans
                        plansFeatures={plansFeatures}
                        show={filterOpen}
                        setfilterOpen={setfilterOpen}
                        selectedFilters={selectedFilters}
                        setselectedFilters={setselectedFilters}
                        resetFilters={resetFilters}
                        updatePlans={updatePlans}
                        allPlansFeatures={allPlansFeatures}
                    />
                )}

                {/* <------------------------------------------------------- Plan Cards ------------------------------------> */}
                <PlanCardsList plans={plans} />
            </main>
            <DidntFindWhatYouWereLookingFor />
            <Testimonials />
            <InnuaPartners />
            <SubscribeToEmailList />
        </>
    );
}

function AllPlansIntros(props) {
    return (
        <section
            id="all-plans-intro"
            className="pt-lg-6 section-header pb-lg-0 mbb-0 bg-white text-dark"
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 col-md-8 text-center">
                        <h1 className="font-size-34 mb-3 d-none d-md-block">
                            Beautiful, affordable Plans & BQs
                        </h1>
                        <h1 className="font-size-24 mb-3 d-block d-md-none">
                            Beautiful, affordable Plans & BQs
                        </h1>
                        <div className="pt-3">
                            <p className="lead font-size-12 text-muted">
                                Browse our catalogue for your dream house plan
                                and turn it into reality
                            </p>
                            <button
                                className="btn btn-outline-gray animate-up-2 mb-3"
                                onClick={() => props.setfilterOpen(true)}
                            >
                                <i className="fas fa-th-large mr-2"></i>
                                FILTER PLANS
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AllPlans;
